const translations = {
  "en": {
    "Adding 3 years of saving": "Adding 3 years of saving",
    "Comparing to a safe cushion": "Comparing to a safe cushion",
    "Compounding to that target": "Compounding to that target",
    "Compounding your investments": "Compounding your investments",
    "Counting your runway": "Counting your runway",
    "Finding people on your path": "Finding people on your path",
    "Finding your debt-free date": "Finding your debt-free date",
    "Modeling your payoff pace": "Modeling your payoff pace",
    "Ordering balances by cost": "Ordering balances by cost",
    "Pinpointing your $1M year": "Pinpointing your $1M year",
    "Pinpointing your work-optional year": "Pinpointing your work-optional year",
    "Pricing the yield you're missing": "Pricing the yield you're missing",
    "Reading what you owe": "Reading what you owe",
    "Reading your cash": "Reading your cash",
    "Reading your cash & spending": "Reading your cash & spending",
    "Reading your income & savings": "Reading your income & savings",
    "Setting aside your safety buffer": "Setting aside your safety buffer",
    "Setting your price ceiling": "Setting your price ceiling",
    "Sizing your borrowing power": "Sizing your borrowing power",
    "Sizing your number (25× spending)": "Sizing your number (25× spending)",
    "Spotting what's sitting idle": "Spotting what's sitting idle",
    "Stress-testing a lost paycheck": "Stress-testing a lost paycheck"
  },
  "zh-tw": {
    "Adding 3 years of saving": "新增3年儲蓄",
    "Comparing to a safe cushion": "相較於安全墊",
    "Compounding to that target": "複利累積至該目標",
    "Compounding your investments": "投資複利成長",
    "Counting your runway": "計算你的資金跑道",
    "Finding people on your path": "尋找與你同行的投資人",
    "Finding your debt-free date": "尋找你的無債日期",
    "Modeling your payoff pace": "模擬你的回報進度",
    "Ordering balances by cost": "按成本排序餘額",
    "Pinpointing your $1M year": "精準設定你的百萬目標年",
    "Pinpointing your work-optional year": "精準推算你能不工作的那一年",
    "Pricing the yield you're missing": "計算你錯失的收益率",
    "Reading what you owe": "正在讀取你的負債",
    "Reading your cash": "正在讀取你的現金",
    "Reading your cash & spending": "正在讀取你的現金與支出",
    "Reading your income & savings": "正在讀取你的收入與儲蓄",
    "Setting aside your safety buffer": "保留你的安全緩衝區",
    "Setting your price ceiling": "設定你的價格上限",
    "Sizing your borrowing power": "計算你的融資能力",
    "Sizing your number (25× spending)": "計算你的目標金額（支出 × 25）",
    "Spotting what's sitting idle": "找出閒置資金",
    "Stress-testing a lost paycheck": "薪資中斷壓力測試"
  }
};

export default translations;
